import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

import type { ViewXlsMacroRendererProps } from '../src/ViewXlsMacroRenderer.tsx';

export const ViewXlsMacroHandler: LoadableType<ViewXlsMacroRendererProps> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ViewXlsMacro" */ '../src/ViewXlsMacroRenderer.tsx'
			)
		).ViewXlsMacroRenderer,
});
